import { createAction } from 'redux-act';

import ReservationSetting from '../../../models/interfaces/ReservationSetting';
import FetchPayload from '../FetchPayload';
import TimestampPayload from '../TimestampPayload';

export interface FetchReservationSettingPayload extends FetchPayload {
  placeUuid: string;
}
export const fetchReservationSetting = createAction<FetchReservationSettingPayload>('FETCH_RESERVATION_SETTING');

export interface ReservationSettingFetchedPayload extends TimestampPayload {
  reservationSetting: ReservationSetting;
}
export const reservationSettingFetched = createAction<ReservationSettingFetchedPayload>('RESERVATION_SETTING_FETCHED');

export interface ReservationSettingFetchFailedPayload extends TimestampPayload {
  placeUuid: string;
}
export const reservationSettingFetchFailed = createAction<ReservationSettingFetchFailedPayload>('RESERVATION_SETTING_FETCH_FAILED');

export type ReservationSettingFetchResponsePayload = ReservationSettingFetchedPayload | ReservationSettingFetchFailedPayload;
